import * as angular from "angular";
import { MapHelperService } from "../map/map.helper";

export class EventHelper {
    private mapHelperService: MapHelperService;

    constructor(MapHelperService: MapHelperService) {
        this.mapHelperService = MapHelperService;
    }

    locate(
        locationAddress: any,
        success: (location: any) => void,
        failure: (error: object) => void
    ): void {
        this.mapHelperService.locateAddress(locationAddress, success, failure);
    }
}

angular.module("event").service("EventHelper", EventHelper);
